import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { AddSurveyQuestionRPC } from "./addSurveyQuestionRPC";

export class AddSurveyQuestionRPCClientImpl extends AddSurveyQuestionRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: AddSurveyQuestionRPC.Request): Promise<LeoRPCResult<AddSurveyQuestionRPC.Response, AddSurveyQuestionRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "survey/AddSurveyQuestion",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      AddSurveyQuestionRPC.ResponseDTO,
      AddSurveyQuestionRPC.Errors.ErrorsDTO,
      AddSurveyQuestionRPC.Response,
      AddSurveyQuestionRPC.Errors.Errors
    >(
      response,
      "survey/AddSurveyQuestion",
      AddSurveyQuestionRPC.Response.fromDTO,
      AddSurveyQuestionRPC.Errors.fromDTO
    );
  }
}
